import React from "react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 flex flex-col">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
        <div className="bg-white/20 p-6 rounded-2xl shadow-lg leading-relaxed">
          <p>
            You must be at least 18 years of age to use Aica Health Services. Caregivers
            who are at least 18 years of age may create an account on behalf of a minor,
            but minors may not use Aica Health. You may not misuse Aica Health services.
            You may not post or transmit through Aica Health or other applications owned
            by AICA Healthtech Pvt Ltd, any content that is illegal, obscene, threatening,
            defamatory, invasive of privacy, infringing of intellectual property rights
            (including publicity rights), otherwise injurious to third parties or
            objectionable, contains or consist of software viruses or any form of "spam"
            or unsolicited commercial electronic messages. You may use Aica Health services
            or GoPillz AI Solutions applications and services only as permitted by law.
            The licenses granted by Aica Health and AICA Healthtech Pvt Ltd terminate if
            you do not comply with these Terms of Use.
          </p>

          <br />
          <h2 className="font-semibold text-lg">Your Account</h2>
          <p>
            You may need your own Aica Health account to use certain GoPillz Services and
            may be required to be logged in to the account and have a valid payment method
            associated with it. If there is a problem charging your selected payment
            method we may charge any other valid payment method associated with your
            account. For your account, you agree to provide and maintain true, current,
            and complete information about yourself. You are responsible for maintaining
            the confidentiality of your account and password and for restricting access to
            your account, and you agree to accept responsibility for all activities that
            occur under your account or password. You may choose to give access to a
            caregiver who can access your account. Except as provided in our Notice of
            Privacy Practices, Aica Health/GoPillz AI Solutions Pvt Ltd reserves the right
            to refuse service, suspend or terminate your account, terminate your rights to
            use services by Aica Health and GoPillz AI Solutions, remove or edit content
            in its sole discretion.
          </p>

          <br />
          <h2 className="font-semibold text-lg">Communications with Aica</h2>
          <p>
            When you use services offered by Aica Health and GoPillz AI Solutions, or send
            emails, text messages, and other communications from your desktop or mobile
            device to us, you may be communicating with us electronically. You consent to
            receive communications (including emails, texts, mobile push notifications, or
            notices and messages on this Web site or through other applications owned by
            AICA Healthtech Pvt Ltd by to any email address, phone number, or mobile
            device associated with your account or otherwise directly or indirectly
            provided to Aica Health or other services owned by AICA Healthtech Pvt Ltd.
            You can retain copies of these communications for your records. You agree that
            all agreements, notices, disclosures, and other communications that we provide
            to you electronically satisfy any legal requirement that such communications
            be in writing. These communications may include personal information about
            your prescriptions, treatment, or benefits, and, in connection with such
            communications, we may use pre-recorded/artificial voice messages and/or
            automatic dialing devices. If you choose to share access to your mobile phone,
            carrier account, email, or Aica Health/ GoPillz account with others those
            individuals might also be able to see this information.
          </p>

          <br />
          <h2 className="font-semibold text-lg">App Permissions</h2>
          <p>
            When you use applications created and owned by AICA Healthtech Pvt Ltd, you
            may grant certain permissions to us for your device. You may be able to change
            the permissions given to us by modifying your device settings.
          </p>
        </div>
      </div>

      {/* ✅ Back to Home button at the bottom */}
      <div className="mt-8 flex justify-center">
        <button
          onClick={() => navigate("/")}
          className="bg-white text-teal-600 px-6 py-3 rounded-full shadow hover:bg-gray-100 transition"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
